import { useState } from "react";
import "./contact_us.css";

const API_BASE = process.env.REACT_APP_API_BASE_URL || 'https://api.mitadtu.in';

const ContactUs = () => {
  const [form, setForm] = useState({ name: "", email: "", phone: "", interest: "", message: "" });
  const [submitting, setSubmitting] = useState(false);
  const [submitMsg, setSubmitMsg] = useState({ type: '', text: '' });

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setSubmitMsg({ type: '', text: '' });
    try {
      const res = await fetch(`${API_BASE}/api/contact-us/public/submit`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form)
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.message);
      setSubmitMsg({ type: 'success', text: data.message });
      setForm({ name: "", email: "", phone: "", interest: "", message: "" });
    } catch (err) {
      setSubmitMsg({ type: 'error', text: err.message || 'Failed to send message' });
    } finally {
      setSubmitting(false);
    }
  };

  const cardsSection1 = [
    {
      logo: "/assets/images/icons/msg.webp",
      title: "Reach us on Email / Phone ",
      subtitle: "Our friendly team is here to help.",
      link: "office.manet@mituniversity.edu.in",
      phone: "020-67652656",
    },
    {
      logo: "/assets/images/icons/briefcase.webp",
      title: "For Admissions",
      subtitle: "Send your application form on",
      link: "admissions.manet@mituniversity.edu.in",
      phone: "7774062354/ 53/ 52/ 51",
      whatsup: "8308010405",
    },
    {
      logo: "/assets/images/icons/school.webp",
      title: "For Placements",
      subtitle: "Career Opportunities Start Here",
      link: "placements.manet@mituniversity.edu.in",
      phone: "020-67652656",
    },
  ];

  const cardsSection2 = [
    {
      logo: "/assets/images/icons/gps.webp",
      title: "Office",
      subtitle:
        "Come say hello to our office HQ. Mon-Fri from 08:30 am to 4:30 pm, Holiday on Sunday",
      text: "Maharashtra Academy of Naval Education and Training (MANET) - Gate No. 140, Rajbaug, Pune-Solapur Highway, Loni-kalbhor, Pune-412201",
    },
  ];

  const Card = ({ logo, title, subtitle, link, phone, whatsup, text }) => (
    <div className="contact-card">
      <div className="contact-card-top">
        <img src={logo} alt="logo" className="contact-logos" />
        <h3 className="innerpage-subheading" style={{ margin: "0px" }}>
          {title}
        </h3>
      </div>

      <div className="contact-card-content">
        {subtitle && (
          <h2 className="subtitle" id="contact-subtitle">
            {subtitle}
          </h2>
        )}

        {link && (
          <a href={`mailto:${link}`} className="contact-link">
            {link}
          </a>
        )}

        {phone && (
          <p className="contact-text">
            Phone :{" "}
            <a
              href={`tel:${phone.replace(/\s+/g, "")}`}
              className="contact-link"
            >
              {phone}
            </a>
          </p>
        )}

        {whatsup && (
          <p className="contact-text">
            WhatsApp :{" "}
            <a
              href={`tel:${whatsup.replace(/\s+/g, "")}`}
              className="contact-link"
            >
              {whatsup}
            </a>
          </p>
        )}

        {text && <p className="contact-text">{text}</p>}
      </div>
    </div>
  );

  return (
    <div className="contact-container">
      <div className="contact-top-section">
        <h1 className="title" style={{ margin: "0px" }}>
          Contact Details
        </h1>
        <p>
          We' love to hear from you. Our friendly team is always here to chat.
        </p>
        <div className="contact-cards-section">
          {cardsSection1.map((item, i) => (
            <Card key={i} {...item} />
          ))}
        </div>
        <div className="contact-cards-section">
          {cardsSection2.map((item, i) => (
            <Card key={i} {...item} />
          ))}

          <div className="contact-card map-card">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3783.8391448310713!2d74.02160147595619!3d18.49094397007696!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2e96c3b18c937%3A0xe1856bf8cd99e4c5!2sManet%20main%20building!5e0!3m2!1sen!2sin!4v1763699722324!5m2!1sen!2sin"
              width="600"
              height="450"
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              className="map-frame"
            ></iframe>
          </div>
        </div>
      </div>

      <div className="contact-form-section">
        <h2 className="innerpage-heading">
          Love to hear form you, get in touch
        </h2>
        {submitMsg.text && (
          <p style={{ color: submitMsg.type === 'success' ? 'green' : 'red', marginBottom: '12px' }}>
            {submitMsg.text}
          </p>
        )}
        <form onSubmit={handleSubmit} className="contact-form">
          {["name", "email", "phone"].map((f) => (
            <input
              key={f}
              name={f}
              type={f === "email" ? "email" : "text"}
              placeholder={f.charAt(0).toUpperCase() + f.slice(1)}
              value={form[f]}
              onChange={handleChange}
              required
            />
          ))}

          <select
            name="interest"
            value={form.interest}
            onChange={handleChange}
            required
          >
            <option value="">What are you interested in?</option>
            {[
              "Admissions",
              "Student Section",
              "Account Section",
              "Hostel",
              "Exam Section",
              "Placement",
            ].map((opt) => (
              <option key={opt} value={opt.toLowerCase()}>
                {opt}
              </option>
            ))}
          </select>

          <textarea
            name="message"
            placeholder="Message"
            value={form.message}
            onChange={handleChange}
            required
          />

          <button className="button" id="contact-form-btn" disabled={submitting}>
            {submitting ? 'Sending...' : 'Send Message'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ContactUs;
